module.exports = __webpack_public_path__ + "img/IMG_1699_WoodMatted.96b94024.jpg";